<template>
  <div>
    <table class="mailTable" v-if="s_showByRow" :style="styleObject">
      <tr v-for="(index,j) in rowCount" :key="j">
        <td class="column">{{tableData[index*2-2].key}}</td>
        <td :colspan="tableData[index*2-1] !== undefined ? 1 : 3">{{tableData[index*2-2].value}}</td>
        <td class="column" v-if="tableData[index*2-1] !== undefined">{{tableData[index*2-1] !== undefined ? tableData[index*2-1].key : ''}}</td>
        <td v-if="tableData[index*2-1] !== undefined">{{tableData[index*2-1] !== undefined ? tableData[index*2-1].value : ''}}</td>
      </tr>
    </table>
    <table class="mailTable" v-else :style="styleObject">
      <tr v-for="(index,i) in rowCount" :key="i">
        <td class="column">{{tableData[index-1].key}}</td>
        <td>{{tableData[index-1].value}}</td>
        <td class="column">{{tableData[rowCount+index-1] !== undefined ? tableData[rowCount+index-1].key : ''}}</td>
        <td>{{tableData[rowCount+index-1] !== undefined ? tableData[rowCount+index-1].value : ''}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      styleObject: {},
      s_showByRow: true,
    };
  },
  props: ['tableData', 'tableStyle', 'showByRow'],
  computed: {
    rowCount: function() {
      return Math.ceil(this.tableData.length/2);
    }
  },
  created() {
    this.styleObject = this.tableStyle;
    if(this.showByRow !== undefined){
      this.s_showByRow = this.showByRow;
    }
  },
}
</script>
<style scoped lang="scss">
  .mailTable{
    width: 100%;
    border-collapse: collapse;
    text-align: center;
    td{
      border: 1px solid rgba(233, 233, 233, 1);
      width: 25%;
      box-sizing: border-box;
      padding: 8px 20px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/tableComponent/TableComponent.vue